var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashLightGrayWhiteBgShortRoundedLightGrayBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 3.5,
    stroke: "#9296AC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9165 13.25C19.6096 13.25 19.3171 13.3627 19.1029 13.5606C18.8891 13.7582 18.7707 14.0244 18.7707 14.3V15.35H25.229V14.3C25.229 14.0244 25.1106 13.7582 24.8967 13.5606C24.6825 13.3627 24.3901 13.25 24.0832 13.25H19.9165ZM27.104 15.35V14.3C27.104 13.5545 26.7834 12.8414 26.2159 12.317C25.6486 11.7929 24.8813 11.5 24.0832 11.5H19.9165C19.1183 11.5 18.351 11.7929 17.7838 12.317C17.2162 12.8414 16.8957 13.5545 16.8957 14.3V15.35H13.5625C13.0447 15.35 12.625 15.7418 12.625 16.225C12.625 16.7082 13.0447 17.1 13.5625 17.1H13.7707V29.7C13.7707 30.4455 14.0912 31.1586 14.6588 31.683C15.226 32.2071 15.9933 32.5 16.7915 32.5H27.2082C28.0063 32.5 28.7736 32.2071 29.3409 31.683C29.9084 31.1586 30.229 30.4455 30.229 29.7V17.1H30.4375C30.9553 17.1 31.375 16.7082 31.375 16.225C31.375 15.7418 30.9553 15.35 30.4375 15.35H27.104ZM15.6457 17.1V29.7C15.6457 29.9756 15.7641 30.2418 15.9779 30.4394C16.1921 30.6373 16.4846 30.75 16.7915 30.75H27.2082C27.5151 30.75 27.8075 30.6373 28.0217 30.4394C28.2356 30.2418 28.354 29.9756 28.354 29.7V17.1H15.6457Z",
    fill: "#9296AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashLightGrayWhiteBgShortRoundedLightGrayBorder);
export default __webpack_public_path__ + "static/media/trashLightGrayWhiteBgShortRoundedLightGrayBorder.80d28d3f512ed82e4b54b181cce19d4e.svg";
export { ForwardRef as ReactComponent };